const showDebug = ["live", "production"].includes(
  document.documentElement.dataset.env
)
  ? false
  : true;

if (navigator.userAgent.indexOf("Windows") !== -1) {
  document.body.classList.add("is-windows");
}

if (navigator.userAgent.indexOf("rv:11.0") !== -1) {
  document.body.classList.add("is-ie-11");
}

if (navigator.appVersion.indexOf("MSIE 10") !== -1) {
  document.body.classList.add("is-ie");
}

import Scroll from "animated-scroll-to";
// import CookieConsent from "cookieconsent";

import LoaderTest from "./tmp/LoaderTest";
import Input from "./components/common/Input";
import autosize from "./components/common/TextareaAutosize";
import Accordion from "./components/common/Accordion";
import Mobile from "./components/common/Mobile";
import Tab from "./components/common/Tab";
import Drawer from "./components/common/Drawer";
import Donate from "./components/common/Donate";
import Drop from "./components/common/Drop";
import dropdown from "./components/common/Dropdown";
import CarouselSwiper from "./components/common/CarouselSwiper";
import Header from "./components/common/Header";
import Urgent from "./components/common/Urgent";
import HeroSub from "./components/common/HeroSub";
// import Main from "./components/common/Main";
import CarouselImg from "./components/common/CarouselImg";
import CarouselMosaic from "./components/common/CarouselMosaic";
import Testimonial from "./components/common/Testimonials";
import AudioPlayer from "./components/common/AudioPlayer";
import Chart from "./components/common/Chart";
import ScrollTo from "./components/common/ScrollTo";
import ProgressBar from "./components/common/ProgressBar";
import Search from "./components/common/Search";
import DynamicTabs from "./components/common/DynamicTabs";
import Lightbox from "./components/common/Lightbox";
import Freeform from "./components/common/Freeform";
import addressLookup from "./forms/addressLookup";
import CarouselNews from "./components/common/CarouselNews";
import PinnedNav from "./components/common/PinnedNav";

import Typer from "./components/common/Typer";
import Map from "./components/common/Map";
import Visitors from "./components/Visitors";

import "./components/common/TextSlider";
// Modernizr-style check for flexbox `gap` support
import { supportsFlexGap } from "./helpers/BrowserCompat";

if (supportsFlexGap()) {
  document.documentElement.classList.add("flexbox-gap");
} else {
  document.documentElement.classList.add("no-flexbox-gap");
}

// test for loader button
new LoaderTest();

// components
new Input();
autosize();
new Accordion();
new Mobile();
const tab = new Tab();
const drawer = new Drawer();
new Donate();
new Drop();
dropdown();
new CarouselSwiper();
new Header();
new Urgent();
// new Main();
new HeroSub();
new CarouselImg();
new Testimonial();
new CarouselMosaic();
new AudioPlayer();
new Chart();
new ScrollTo();
new ProgressBar();
new Search();
new DynamicTabs();
new Lightbox();
new Freeform();
new CarouselNews();
new PinnedNav();

new Map();
new Visitors();

if (window.location.hash === "#giving") {
  drawer.searchDrawer("OPEN", drawer._drawerInitElements[0]);
}

if (window.location.hash === "#giving-monthly") {
  drawer.searchDrawer("OPEN", drawer._drawerInitElements[0]);
  tab._tab[1];
  tab.getContent(tab._tab[1], tab._tab[1].dataset.id);
  tab.switchHeader(tab._tab[1].dataset.id);
}

window.onhashchange = function () {
  if (window.location.hash === "#giving") {
    drawer.searchDrawer("OPEN", drawer._drawerInitElements[0]);
  }

  if (window.location.hash === "#giving-monthly") {
    drawer.searchDrawer("OPEN", drawer._drawerInitElements[0]);
    tab._tab[1];
    tab.getContent(tab._tab[1], tab._tab[1].dataset.id);
    tab.switchHeader(tab._tab[1].dataset.id);
  }
};

const btns = document.querySelectorAll(".btn");
const formatHash = /#/;
const formatDonationLink = /give.ijm.org/;

for (var i = 0; i < btns.length; i++) {
  let link = btns[i];

  link.addEventListener("click", (event) => {
    const target = link.href;

    if (formatHash.test(target) && !formatDonationLink.test(target)) {
      const hash = target.split("#")[1];

      if (hash !== "giving" && hash !== "giving-monthly") {
        event.preventDefault();
        const element = document.getElementById(hash);
        Scroll(element);
      }
    }
  });
}
/*
const mobileGive = document.getElementById('mobile-give')

mobileGive.addEventListener('click', (event) => {
  event.preventDefault()

  const form = document.querySelector('div.active.jsTabSection form')
  form.submit()
});
 */
// window.addEventListener("load", function(){
// window.cookieconsent.initialise({
//   "cookieconsent.hasTransition": false,
//   "palette": {
//     "popup": {
//       "background": "#353439",
//       "text": "#fafafa"
//     },
//     "button": {
//       "background": "#f8c050",
//       "text": "#353439"
//     }
//   },
//   "position": "bottom",
//   "theme": "block",
//   "content": {
//     "message": "Door op ‘Accepteer alle cookies” te klikken, gaat u akkoord met het opslaan van cookies op uw apparaat, om website-navigatie te verbeteren, website-gebruik te analyseren en bij te dragen aan onze marketingactiviteiten.",
//     "dismiss": "Accepteer alle cookies",
//     "link": "Privacy verklaring",
//     "href": "/privacy-verklaring",
//     "target": "_blank"
//   }
// })});

const freeformForms = document.querySelectorAll(".jsFreeform");
freeformForms.forEach((formElement) => {
  const postalCodeField =
    formElement.querySelector("#Postcode") ??
    formElement.querySelector("#postcode");
  const houseNumberField =
    formElement.querySelector("#Huisnummer") ??
    formElement.querySelector("#huisnummer");
  const additionField =
    formElement.querySelector("#Toevoeging") ??
    formElement.querySelector("#toevoeging");
  const streetField =
    formElement.querySelector("#Straat") ??
    formElement.querySelector("#straat");
  const cityField =
    formElement.querySelector("#Plaats") ??
    formElement.querySelector("#plaats");
  const countryField =
    formElement.querySelector("#Land") ??
    formElement.querySelector("#Land2") ??
    formElement.querySelector("#land") ??
    formElement.querySelector("#land2");
  if (
    postalCodeField &&
    houseNumberField &&
    streetField &&
    cityField &&
    countryField
  ) {
    if (showDebug) console.warn("Ok to execute address API lookup");
    addressLookup(
      postalCodeField,
      houseNumberField,
      countryField,
      streetField,
      cityField
    );
  } else {
    if (showDebug) console.warn("Can't find all 5 fields for address lookup.");
    if (showDebug) console.log({ postalCodeField });
    if (showDebug) console.log({ houseNumberField });
    if (showDebug) console.log({ streetField });
    if (showDebug) console.log({ cityField });
    if (showDebug) console.log({ countryField });
    return false;
  }
});
